import { useState } from 'react';
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react';
import { IconX } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { selectCartTotalPrice } from 'store/selectors/cartSelectors';
// import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { rupiah } from 'lib/currency';
// import { API_URL, get } from 'lib/network/api';
import CartSimple from '../pages/Checkout/ComponentsPage/CartSimple';

const Cart = ({ drawerOpen, setDrawerOpen }) => {
  const navigation = useNavigate();
  const cartData = useSelector((state) => state.cart.data);
  const subtotal = useSelector(selectCartTotalPrice);
  const taxRate = 0.1; // 10%
  const tax = subtotal * taxRate;
  const grandTotal = subtotal + tax;

  const [searchParams] = useSearchParams();
  const currentParams = qs.parse(searchParams.toString(), { comma: true });
  const [query, setQuery] = useState({
    page: 1,
    limit: 50,
  });

  // const fetchCartList = async (query, currentParams) => {
  //   const { page, limit } = currentParams;

  //   const params = {
  //     page: page ? page : query.page,
  //     limit: limit ? limit : query.limit,
  //   };

  //   return get(`${API_URL}/api/cart`);
  // };

  // const { data, isLoading, error } = useQuery({
  //   queryKey: ['fetchCartList', query, currentParams],
  //   queryFn: async ({ queryKey }) => fetchCartList(queryKey[1], queryKey[2]),
  // });
  const goToCheckout = (paramsId) => {
    navigation(`/checkout?id=${paramsId}&type=class`);
  };

  return (
    <Dialog open={drawerOpen} onClose={setDrawerOpen} className="relative z-[110] font-poppins">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-700/30 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
      />

      <div className="pointer-events-none fixed top-0 bottom-0 right-0 flex max-w-full pl-10">
        <DialogPanel
          transition
          className={`pointer-events-auto w-screen max-w-sm transform transition duration-500 ease-in-out data-[closed]:translate-x-full`}>
          <div className="relative flex h-full flex-col bg-white shadow-xl rounded-l-2xl px-4 text-kin-text">
            <div className="flex flex-row flex-shrink-0 justify-between gap-2 py-4 border-b-[0.5px] border-kin-text">
              <span className="text-base leading-6 !font-semibold">Your Cart</span>
              <button
                type="button"
                onClick={() => setDrawerOpen(!drawerOpen)}
                className="relative rounded-md bg-white text-kin-text hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-main focus:ring-offset-1">
                <span className="sr-only">Close panel</span>
                <IconX aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
            {cartData.length === 0 ? (
              <div className="divide-y-[0.5px] divide-kin-text">
                <p>Your cart is empty</p>
              </div>
            ) : (
              <div className="divide-y-[0.5px] divide-kin-text overflow-y-scroll h-[150vh] pb-[250px]">
                {cartData.map((item, idx) => {
                  return (
                    <div key={idx}>
                      <CartSimple item={item} />
                    </div>
                  );
                })}
              </div>
            )}
            <div className="absolute bottom-0 w-full px-4 left-0 right-0 bg-kin-textsecondary">
              <div>
                <dl className="space-y-2 py-4 text-sm text-kin-text">
                  <div className="flex justify-between">
                    <dt className="font-light">SUBTOTAL</dt>
                    <dd className="font-semibold">{rupiah(subtotal)}</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="font-light">TAX 10%</dt>
                    <dd className="font-semibold">{rupiah(tax)}</dd>
                  </div>
                </dl>
              </div>
              <div className="border-b-[0.5px] border-kin-text" />
              <div className="pb-4 text-center">
                <dl className="space-y-2 py-4 text-sm text-kin-text">
                  <div className="flex justify-between">
                    <dt className="font-light">GRAND TOTAL</dt>
                    <dd className="font-semibold">{rupiah(grandTotal)}</dd>
                  </div>
                </dl>
                <button
                  onClick={() => goToCheckout()}
                  className="w-full bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
                  <span className="text-xs font-semibold block">PROCEED TO CHECKOUT</span>
                </button>
                <span className="text-center text-kin-text text-xs font-light">
                  Terms & conditions apply to special events and classes.
                </span>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default Cart;
